import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const session_id = params.get("session_id");
    if (!session_id) { setStatus("error"); return; }
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          const me = await api.get("/auth/me");
          setUser(me.data);
          setTimeout(() => nav("/app"), 2000);
          return;
        }
        if (tries > 20) { setStatus("timeout"); return; }
        setTries(t => t+1);
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8" data-testid="payment-success-page">
      <div className="card-flat p-10 max-w-md text-center">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="animate-spin mx-auto text-primary"/>
            <div className="mt-6 font-display font-bold text-2xl tracking-tight">Confirming your payment...</div>
            <div className="text-sm text-muted-foreground mt-2">This takes a few seconds.</div>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-emerald-400"/>
            <div className="mt-6 font-display font-bold text-3xl tracking-tight">Welcome to Pro</div>
            <div className="text-sm text-muted-foreground mt-2">Redirecting to your dashboard...</div>
          </>
        )}
        {status === "error" && (
          <div className="text-muted-foreground">Payment could not be verified. Check your subscription page.</div>
        )}
        {status === "timeout" && (
          <div className="text-muted-foreground">Still processing. Please refresh in a minute or check the pricing page.</div>
        )}
      </div>
    </div>
  );
}
